import { isCustomerFeatureEnabled } from 'src/data/customer';
import { getCustomerPlan, isEnterpriseOrAcePlan } from 'src/data/subscription';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';
import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerHasAccessToInfinity = () => {
  const customer = useCurrentCustomer();

  // Check if customer is on "business" or "enterprise" plan
  const plan = getCustomerPlan(customer);
  const isBusinessOrEnterprise = isEnterpriseOrAcePlan(plan);

  // Check if "infinityExtension" feature flag is enabled
  const customerHasFeatureFlag = isCustomerFeatureEnabled(
    customer,
    BE_CUSTOMER_FEATURES.infinityExtension
  );

  return isBusinessOrEnterprise || customerHasFeatureFlag;
};
